export const SELECT_CONTACT_FOR_CONTRACT =
  "generateContract.SELECT_CONTACT_FOR_CONTRACT";

export const GENERATING_CONTRACT = "generateContract.GENERATING_CONTRACT";
export const CONTRACT_GENERATED = "generateContract.CONTRACT_GENERATED";
export const GENERATING_CONTRACT_FAILED =
  "generateContract.GENERATING_CONTRACT_FAILED";
